import { RouteItem } from "../../navigation/appRoutes"

interface BreadcrumbItem {
    route: RouteItem,
    resolvedPath: string
}

export class BreadcrumbHelper {
    static matchRoute = (path: string, routes: RouteItem[]): BreadcrumbItem | undefined => {
        const segments = path.split("/").filter(Boolean)

        const candidates = routes.filter(route => {
            const routeSegments = route.path.split("/").filter(Boolean)

            if (routeSegments.length > segments.length)
                return false

            return routeSegments.every((seg, idx) => {
                if (seg.startsWith(":")) return true
                return seg === segments[idx]
            })
        })

        const bestMatch = candidates.sort((a, b) => b.path.length - a.path.length)[0]
        if (!bestMatch) return undefined;

        const routeSegments = bestMatch.path.split("/").filter(Boolean);
        const resolvedSegments = routeSegments.map((seg, idx) =>
            seg.startsWith(":") ? segments[idx] : seg
        );

        const resolvedPath = "/" + resolvedSegments.join("/");

        return {
            route: bestMatch,
            resolvedPath
        };
    }
}
